import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant �l�ment de documentation
 * @extends BaseComponent
 */
@Component({
  selector: 'app-element-documentation',
  templateUrl: './element-documentation.component.html',
  styleUrls: ['./element-documentation.component.scss']
})
export class ElementDocumentationComponent extends BaseComponent implements OnInit {

    private readonly urlPrevisualisation: string = 'http://view.officeapps.live.com/op/view.aspx?src=';

    @Input() documentation: any = null;

    /**
     * Constructeur
     * @param sanitizer
     */
    constructor(private sanitizer: DomSanitizer) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Obtenir le lien de pr�visualisation
     * @param doc La documentation
     */
    lienPrevisualisation(doc) {
        let lien = doc.LienFichier || doc.Lien;
        let utiliserReader = doc.UtiliserReader;
        if (utiliserReader) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(this.urlPrevisualisation + encodeURIComponent(lien));
        }
        else {
            return this.sanitizer.bypassSecurityTrustResourceUrl(lien);
        }
    }
}
